import { Grid } from "react-feather"
import { ACL_MANAGE, ACL_SUBJECT_SERVICE } from "@configs/acl/constants"

export default [
    {
        id: "applications",
        title: "Services",
        icon: <Grid size={20} />,
        children: [
            {
                id: "applicationCyber",
                title: "serviceCyber",
                icon: <Grid size={20} />,
                navLink: "/applications/application-cyber",
                action: ACL_MANAGE,
                resource: ACL_SUBJECT_SERVICE
            }
            // {
            //     id: "serviceOther",
            //     title: "serviceOther",
            //     icon: <Grid size={20} />,
            //     navLink: "/services/service-other",
            //     action: ACL_MANAGE,
            //     resource: ACL_SUBJECT_SERVICE
            // }
        ]
    }
]
